import { render, staticRenderFns } from "./Autoasignar.vue?vue&type=template&id=a81909da"
import script from "./Autoasignar.vue?vue&type=script&lang=js"
export * from "./Autoasignar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports